import { ISequenceStep, SequenceStepType } from '../interfaces/models/campaign';

export const SEQUENCE_STEP_LABELS: Record<SequenceStepType, string> = {
  connection_request: 'Connection request',
  message: 'Message',
  sn_message: 'InMail / Open Profile',
  profile_visit: 'Profile visit',
  post_like: 'Post like',
  post_comment: 'Post comment',
  email: 'Email',
};

export function formatSequenceSummary(steps: ISequenceStep[]): string {
  if (!steps.length) return 'No steps configured';
  return steps.map(s => SEQUENCE_STEP_LABELS[s.type]).join(' → ');
}

export function formatSequenceSummaryWithDays(steps: ISequenceStep[]): string {
  if (!steps.length) return 'No steps yet — add at least one';
  return steps
    .map(s => `${SEQUENCE_STEP_LABELS[s.type]} (Day ${Math.max(0, parseInt(String(s.delayDays ?? 0), 10) || 0)})`)
    .join(' → ');
}
